import type { LucideProps } from 'lucide-react'

export function BaseIcon({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            {...props}
        >
            <rect width="7" height="7" x="3" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="3" rx="1" />
            <rect width="7" height="7" x="14" y="14" rx="1" />
            <rect width="7" height="7" x="3" y="14" rx="1" />
        </svg>
    )
}

export function BaseIconGradient({ className, ...props }: LucideProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            {...props}
        >
            <defs>
                <linearGradient id="base-icon-gradient" x1="3" y1="3" x2="21" y2="21" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#2563EB" /> {/* blue-600 */}
                    <stop offset="1" stopColor="#9333EA" /> {/* purple-600 */}
                </linearGradient>
            </defs>
            <rect width="7" height="7" x="3" y="3" rx="1" fill="url(#base-icon-gradient)" stroke="none" />
            <rect width="7" height="7" x="14" y="3" rx="1" fill="url(#base-icon-gradient)" stroke="none" />
            <rect width="7" height="7" x="14" y="14" rx="1" fill="url(#base-icon-gradient)" stroke="none" />
            <rect width="7" height="7" x="3" y="14" rx="1" fill="url(#base-icon-gradient)" stroke="none" />
        </svg>
    )
}
